module.exports = __webpack_public_path__ + "static/media/lighthouse.353fa9d2.svg";